module.exports = "<div class=\"input-suggestion-container\">\n  <div class=\"input-wrapper\">\n    <input type=\"text\" name=\"input-text\"\n      id=\"{{ inputId }}-control\"\n      class=\"form-control input-suggestion\"\n      placeholder=\"{{ inputPlaceholder }}\"\n      [(ngModel)]=\"textValue\" />\n    <span><i class=\"icon-search left-icon\"></i></span>\n    <span *ngIf=\"textValue?.length > 0\" (click)=\"onClearButtonClicked($event)\">\n      <i class=\"icon-close right-icon\" id=\"btn-clear-input\"></i>\n    </span>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input-suggestion/input-suggestion.component.html
// module id = 1035
// module chunks = 22